import style from "@styles/pages/flow/boxes/Box.module.scss";
import classnames from "classnames/bind";
import { Handle } from "reactflow";

export default ({
  id,
  title,
  valid = true,
  children,
  footer,
  selected,
  isConnectable,
}) => {
  const cx = classnames.bind(style);

  return (
    <div className={cx({ selected: selected })}>
      <Handle
        type="target"
        position="left"
        className={style.handleTarget}
        isConnectable={isConnectable}
      />
      <div className={cx({ inner: true, needsSetup: !valid })}>
        <div className={style.body}>
          <div className="d-flex justify-between align-center">
            <div className={`${style.title} flex`}>{title}</div>
          </div>
          {children}
        </div>
        {footer}
      </div>
    </div>
  );
};
